import { P } from "../../../../../../AbstractElements";
import CommonFileUpload from "../../../../../CommonComponents/CommonFileUpload";

const ProductGallery = () => {
  return (
    <div className="product-upload">
      <P>
        Product Gallery<span className="text-danger"> *</span>
      </P>
      <CommonFileUpload />
    </div>
  );
};

export default ProductGallery;
